// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__74s82","newExpiryDate":"styles_newExpiryDate__1yr2l","footer":"styles_footer__yB9ox"};